import React, { ReactElement } from 'react';
import { Settings } from 'react-slick';

import { Carousel } from '../../../../shared/Carousel/Carousel';
import { IActiveExperienceWinner } from '../useActiveExperienceWinners';

import styles from './WinnersCarousel.styles.css';

type IWinnersCarouselProps = {
    winners: IActiveExperienceWinner[];
    'data-testid'?: string;
};

/** tracks clicks and swipes */
function trackInteraction (): void {
    window.SDG.Analytics.events.pushDataLayerEvent({
        event: 'click',
        /* eslint-disable camelcase */
        ga_action: 'Winner Carousel Interaction',
        ga_category: 'Winner Carousel',
        ga_label: 'Winner Carousel Interaction',
        /* eslint-enable camelcase */
    });
}

export function WinnersCarousel (props: IWinnersCarouselProps): ReactElement | null {
    const { winners, 'data-testid': dataTestId }: IWinnersCarouselProps = props;
    const MIN_WINNERS_COUNT: number = 4;

    if (winners.length < MIN_WINNERS_COUNT) {
        return null;
    }

    const slickSettings: Settings = {};

    function onBeforeChange (): void {
        trackInteraction();
    }

    return (
        <Carousel settings={slickSettings} items={winners} onBeforeChange={onBeforeChange} data-testid={dataTestId}>
            <div className="flex justify-between items-center mb-2 mt-7">
                <Carousel.Header>
                    <h3 className="font-bold font-gellix text-xl lg:text-2xl text-gray-900">Meet some recent winners!</h3>
                </Carousel.Header>
                <Carousel.Pagination />
            </div>
            <Carousel.Content>
                {winners.map((winner: IActiveExperienceWinner, index: number): ReactElement => {
                    return (
                        <Carousel.Item key={index}>
                            <div className={`flex flex-col items-center pb-3 pt-4 px-3 bg-navy-50 rounded ${styles.card}`}>
                                <img src={winner.image.src} alt={winner.image.alt} className={`rounded-full aspect-square object-cover ${styles.image}`} />
                                <p className="mt-2 text-base font-gellix text-center line-clamp-3">{winner.copy}</p>
                            </div>
                        </Carousel.Item>
                    );
                })}
            </Carousel.Content>
        </Carousel>
    );
}
